/**
 * CartIcon - Shopping cart icon with item count badge
 * Phase C4: Cart Icon & Mini Cart
 * 
 * Usage:
 * <CartIcon onCartClick={() => setShowMiniCart(true)} />
 */

import React from 'react';
import { useCart } from '../hooks/useCart';
import { useNavigate } from 'react-router-dom';
import './CartIcon.css';

const CartIcon = ({ onClick, className = '' }) => {
  const { itemCount, reservedBookingsCount } = useCart();
  const navigate = useNavigate();
  const hasReservedBookings = reservedBookingsCount > 0;

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: navigate to cart page
      navigate('/cart');
    }
  };

  return (
    <button 
      className={`cart-icon-button ${className}`}
      onClick={handleClick}
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="cart-icon-svg"
      >
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
      </svg>
      {itemCount > 0 && (
        <span className="cart-icon-badge">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
      {hasReservedBookings && (
        <span className="cart-booking-indicator" title={`${reservedBookingsCount} service${reservedBookingsCount > 1 ? 's' : ''} reserved`}>
          📅
        </span>
      )}
    </button>
  );
};

export default CartIcon;
